import { OnInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ParametrosFiltrosSolicitudSuministrosEntity, EntidadEmpresarial, FiltrosSolicitudesSuministrosEntity, ServicioSolicitudesSuministroService,
  DataSolicitudSuministrosBodyEntity
} from '../../services/servicio-solicitudes-suministro.service';
import { HttpErrorResponse } from '@angular/common/http';
import { InformacionUsuario } from '../../services/servicio-solicitudes-suministro.service';

/*
Autor: David Centeno
email: davidcenteno@outlook.es
Fecha de creación: 4 de Septiembre de 2019
*/

@Component({
  selector: 'app-reporte-solicitudes-suministros',
  templateUrl: './reporte-solicitudes-suministros.component.html',
  styleUrls: ['./reporte-solicitudes-suministros.component.css']
})

export class ReporteSolicitudesSuministrosComponent implements OnInit {
  loading: boolean;
  fechaImpresion: Date;

  filtrosSeleccionados: FiltrosSolicitudesSuministrosEntity;
  dataSuministros: DataSolicitudSuministrosBodyEntity[] = [];

  public parametrosEntity: ParametrosFiltrosSolicitudSuministrosEntity = {
    codigoBaseDatos: '',
    uncoAdmisionInspecciona: '',
    uncoSede: '',
    uncoLogin: ''
  };

  public filtrosEntity: FiltrosSolicitudesSuministrosEntity = {
    estadoSolicitud: '',
    medicamentos: '',
    codigoBaseDatos: '',
  };

  public entidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: '',
  };

  public informacionUsuario: InformacionUsuario = {
    nombreUsuario: '',
    codigoBarrasImprime: '',
  };


  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioSolicitudSuministro: ServicioSolicitudesSuministroService,
  ) {

    this.activatedRoute.params.subscribe(params => {
      this.parametrosEntity.codigoBaseDatos = params['codigoBaseDatos'];
      this.parametrosEntity.uncoAdmisionInspecciona = params['uncoAdmisionInspecciona'];
      this.parametrosEntity.uncoSede = params['uncoSede'];
      this.parametrosEntity.uncoLogin = params['uncoLogin'];
      this.filtrosSeleccionados = this.filtrosEntity;
    });
  }

  ngOnInit() {
    this.filtrosSeleccionados = this.filtrosEntity;
  }

  public onFiltrosCompletados(obj: FiltrosSolicitudesSuministrosEntity) {
    this.filtrosSeleccionados = obj;
    this.loading = true;
    this.filtrosSeleccionados.codigoBaseDatos = this.parametrosEntity.codigoBaseDatos;
    this.fechaImpresion = new Date();
    // this.getLogo(obj.codigoBaseDatos);
    this.getData();
  }

  public updateInfoEntidad(entidad: EntidadEmpresarial) {
    this.entidadEmpresarial = entidad;
  }
  public updateInfoUsuario(usuario: InformacionUsuario) {
    this.informacionUsuario = usuario;
  }

  getLogo(codigoBaseDatos: string) {
  }

  mostrarLoadingFiltros(event: any) {
    this.loading = true;
  }

  async getData() {
    try {
      const response = await this.servicioSolicitudSuministro.getDataReporte(this.filtrosSeleccionados, this.parametrosEntity);

      if (response != null) {
        response.subscribe((data: DataSolicitudSuministrosBodyEntity[]) => {
          this.dataSuministros = data;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
    } catch (e) {
      console.log(e);
      this.loading = false;
    }

  }

}
